import { render } from "./CobaltTestResultsTable.vue?vue&type=template&id=05627c73&scoped=true"
import script from "./CobaltTestResultsTable.vue?vue&type=script&lang=js"
export * from "./CobaltTestResultsTable.vue?vue&type=script&lang=js"

import "./CobaltTestResultsTable.vue?vue&type=style&index=0&id=05627c73&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05627c73"]])

export default __exports__